/**
 * Dependencies.
 */
import { createElement as el } from "@wordpress/element";
import TabPanel from "../TabPanel/TabPanel";
import AppConfig from "../../services/appConfig";
import Tab from "../../interfaces/iTab";

interface TabLayoutProps {
  readonly Tabs: Tab[];
  readonly initialTabName?: string;
}

/**
 * Provides a TabLayout.
 *
 * @return {element} TabLayout.
 */
const TabLayout = (props: TabLayoutProps) => {
  const { Tabs, initialTabName = "switcher" } = props;
  const { wpDebug = false } = AppConfig();

  /**
   * @returns boolean
   */
  const parseBool = (b: any) => {
    return !/^(false|0)$/i.test(b) && !!b;
  };

  /**
   * Tab select callback.
   *
   * @param tab
   * @returns
   */
  const onTabSelect = (tab: Tab) => {
    return tab.callback();
  };

  /**
   * @returns boolean
   */
  const isWpDebug = () => {
    return parseBool(wpDebug);
  };

  /**
   * @param tab Tab
   * @returns boolean
   */
  const isAccessible = (tab: Tab) => {
    const { inDebugModeOnly = false, active = true } = tab;
    if (!active) {
      return false;
    }

    if (!inDebugModeOnly) {
      return true;
    }
    if (isWpDebug()) {
      return true;
    }
    return false;
  };

  var activeTabs: Tab[] = [];
  Tabs.forEach((tab: Tab) => {
    if (isAccessible(tab)) {
      activeTabs.push(tab);
    }
  });

  return el(
    TabPanel,
    {
      name: "WPGlobusSwitcherTabPanel",
      className: "wpglobus-switcher-tab-panel",
      activeClass: "is-active",
      tabs: activeTabs,
      initialTabName: initialTabName,
    },
    onTabSelect
  );
};

export default TabLayout;
